import React from 'react';
import { useAuth } from '../hooks';
import { User } from '../models';

interface UserContextType {
  user: User | undefined;
  authStateLoading: boolean;
}

export const UserContext = React.createContext<UserContextType>({
  user: undefined,
  authStateLoading: true
});

const UserProvider: React.FC = ({ children }) => {

  const { user, authStateLoading } = useAuth();

  const context: UserContextType = {
    user,
    authStateLoading,
  };

  return (
    <UserContext.Provider value={context}>{children}</UserContext.Provider>
  );
};

export default UserProvider;
